<template>
    <div class="page-restore-await">
        <div class="block-title">Восстановление пароля</div>

        <div class="text">
            На указанный электронный адрес направлено письмо для восстановления пароля
        </div>

        <div class="form-field">
            <div class="value">
                <router-link class="accent" to="/user/login">Перейти к входу</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.page-restore-await {
    .text {
        letter-spacing: 0.005em;
    }
}
</style>
